import React from "react";
import "./style.scss";

import becomingMentor from "./img/becoming-mentor.png";
import roleMentor from "./img/role-of-mentor.png";
import HTMLReactParser from "html-react-parser";
import { useTranslation } from 'react-i18next';
export default function RoleMentor(props) {
  const { t } = useTranslation();
  const keyData = props.data;
  keyData[0].Text=`<p class='benefitMentorData'>${t('Based_on_the_feedback')}</p>\r\n`;
  keyData[1].Text=`<p class='benefitMentorData'>${t('Invitation_to_national_and_international')}</p>\r\n`;
  keyData[2].Text=`<p class='benefitMentorData'>${t('Receive_mentor_badges')}</p>\r\n`;

  return (
    <div className="role-mentor">
      <section className="benefitsBG">
        <div className="w-100 pt-50 pb-0 position-relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-sm-12 col-lg-12"></div>
              <div
                className="col-md-12 col-sm-12 col-lg-12 wow fadeInDown"
                style={{ marginBottom: "5px" }}
              >
                <div
                  className="sec-title text-center w-100 position-relative"
                  style={{ paddingBottom: "0px" }}
                >
                  <h2 className="mb-0 homepageFirstHeader">
                  {t('The_Role_of_a_Mentor')}
                    {/* The Role of a Mentor */}
                     </h2>
                </div>
              </div>
              <div
                className="col-md-12 col-sm-12 col-lg-12 wow fadeInDown"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div
                  className="rol-of-mentor "
                  style={{
                    width: "fit-content",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                  }}
                >
                  <p className="homepageFirstDescription" style={{ marginTop: "0px", fontSize: "20px" }}>
                  {t('Give_Community_And_The_Country')}
                    {/* Give Back To The Community And The Country */}
                  </p>
                </div>
              </div>
              <div className="col-md-1 col-sm-12 col-lg-1"></div>
            </div>

            <div className="row" style={{ paddingTop: "20px" }}>
              <div className="col-md-2 col-sm-6 col-lg-2"></div>
              <div className="col-md-8 col-sm-6 col-lg-8 ">
                <div
                  className="mckp-img text-center tilt w-100"
                  data-max_tilt="10"
                  data-perspective="1000"
                  data-scale="1"
                  data-speed="700"
                  style={{
                    transform:
                      "perspective(1000px) rotateX(0deg) rotateY(0deg)",
                    willChange: "transform",
                  }}
                >
                  <img className="img-fluid" src={roleMentor} alt="" />
                </div>
              </div>
              <div className="col-md-2 col-sm-6 col-lg-2"></div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="bg"
      >
        <div className="w-100 pt-50 pb-0 position-relative">
          <div className="container">
            <div className="row">
              <div className="col-md-7 col-sm-12 col-lg-8">
                <div className="content">
                  <h2 className="mb-0 homepageFirstHeader">
                  {t('Benefits_of_Becoming_a_Mentor')}
                    {/* Benefits of Becoming a Mentor */}
                    </h2>
                  <br />
                  <p className="homepageFirstDescription" style={{ fontSize: "20px" ,textAlign: "justify"}}>
                  {t('Share_your_expertise')}
                    {/* Share your expertise with the startup community and
                    contribute indirectly to the economy and job creation of
                    India. */}
                  </p>
                </div>
                <div className="row">
                  {keyData.map((data, index) => {
                    return (
                      <div className="col-md-4 col-6 col-lg-4 checkFit" key={index}>
                        {" "}
                        <div
                          className="button-benefits wow slideInLeft circlebenefitsdiv"
                          style={{ pointerEvents: "none" }}
                        >
                          <h4 className="mb-0">{data.Heading}</h4>
                        </div>
                        <div className="benefitMentorText homepageFirstDescription">
                        {HTMLReactParser(data.Text)}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="col-md-5 col-sm-11 col-lg-4 wow slideInRight">
                
                <div className="pm-img">
                  <div
                    className="mckp-img text-center tilt w-100"
                    data-max_tilt="10"
                    data-perspective="1000"
                    data-scale="1"
                    data-speed="700"
                  >
                    <img className="img-fluid" src={becomingMentor} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
